// extracted by mini-css-extract-plugin
module.exports = {"container":"fW","overlay":"gW","headingSection":"hW","close":"iW","copy":"jW","m-heart-activate":"kW","bottomSection":"lW","disabled":"mW","m-heart-pulse":"nW"};